import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Link as ReactLink,
  useNavigate,
  useLocation,
  useParams,
} from "react-router-dom";
import {
  Box,
  Button as MuiButton,
  CircularProgress,
  Container,
  IconButton,
  Skeleton,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import AppContext from "../../AppContext";
import { Button } from "../basic/Button";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import { TextField } from "../basic/TextField";
import { SelectedInterestsAutocomplete } from "../complex/SelectedInterestsAutocomplete";
import { CountrySelectField } from "../complex/CountrySelectField";
import { ResponsiveLayoutSidebar } from "../complex/ResponsiveLayoutSidebar";
import { OnboardingScreenResponsiveLayout } from "../complex/OnboardingScreenResponsiveLayout";
import { ScreenNavHeader } from "../complex/ScreenNavHeader";
import { UploaderButton } from "../complex/UploaderButton";
import { AppDialog } from "../complex/AppDialog";
import EditIcon from "@mui/icons-material/Edit";
import uploadImages from "./sharedFunctions/uploadImages";
import validateEmail from "../utils/validateEmail";
import getUser from "./queries/getUser";
import { generateClient } from "aws-amplify/api";
import { use } from "react";
const client = generateClient();

const acceptableFiles = ["jpeg", "jpg", "png"];
const capitalizeWords = (string) => {
  const words = string.split(" ");
  const newString = words
    .map((word) => {
      if (word.length > 0) {
        return word[0]?.toUpperCase() + word?.slice(1);
      }
      {
        return word;
      }
    })
    .join(" ");
  return newString;
};

const theme = createTheme({
  palette: {},
  components: {
    // MuiTextField: {
    //   styleOverrides: {
    //     root: {
    //     },
    //   },
    // },
  },
});

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const EmailVerificationBody = (props) => {
  const [state, setState] = useState({
    stage: 0,
  });

  const onChangeEmail = (event) => {
    const local_p = { submission: {} };
    const value = event.currentTarget.value;
    local_p.submission = {
      ...local_p.submission,
      email: value,
    };

    if (validateEmail(value)) {
      local_p.errors = {
        ...local_p.errors,
        email: false,
      };
    } else {
      local_p.errors = {
        ...local_p.errors,
        email: "Enter a valid first email address.",
      };
    }
    setState({
      ...state,
      submission: local_p.submission,
      errors: local_p.errors,
    });
  };

  const onChangeEmailVerificationCode = (event) => {
    const local_p = { submission: {} };
    const value = event.currentTarget.value;
    local_p.submission = {
      ...local_p.submission,
      emailVerificationCode: value,
    };

    if (validateEmail(value)) {
      local_p.errors = {
        ...local_p.errors,
        emailVerificationCode: false,
      };
    } else {
      local_p.errors = {
        ...local_p.errors,
        emailVerificationCode: "Invalid verification code.",
      };
    }
    setState({
      ...state,
      submission: local_p.submission,
      errors: local_p.errors,
    });
  };

  const nextStep = () => {
    setState({ ...state, stage: state.stage + 1 });
  };

  useEffect(() => {
    (async () => {
      if (state.stage === 1) {
        try {
          props?.q?.updateState(props?.globalState);
          const res = await props?.q?.doQuery(
            "setSingeUserField",
            "Verification code sent",
            "An error occured",
            {
              submission: state?.submission,
            },
            props?.p,
            props?.p?.userData?.userId,
            "tempEmail",
            `"${state?.submission?.email}"`
          );

          console.log("res", res);
        } catch (error) {
          console.log("error", error);
        }
      }
      if (state.stage === 2) {
        try {
          props?.q?.updateState(props?.globalState);
          const res = await props?.q?.doQuery(
            "setSingeUserField",
            "Email updated",
            "An error occured",
            {
              submission: state?.submission,
            },
            props?.p,
            props?.p?.userData?.userId,
            "sentEmailVerificationCode",
            state?.submission?.emailVerificationCode
          );

          console.log("res", res);
        } catch (error) {
          console.log("error", error);
        }
      }
    })();
  }, [state.stage]);

  return (
    <>
      {state?.stage === 0 && (
        <Stack px={3} width={300}>
          <Box mb={2}>
            <Typography variant="body1">
              Enter your new email address.
            </Typography>
          </Box>
          <Stack mb={2}>
            <TextField
              required
              onChange={onChangeEmail}
              error={state.errors?.email ? true : false}
              value={state.submission?.email || ""}
              fullWidth={true}
              label="Email"
            />
          </Stack>
          <Button onClick={nextStep}>Send Verification Code</Button>
        </Stack>
      )}

      {state?.stage === 1 && (
        <Stack px={3} width={300}>
          <Box mb={2}>
            <Typography variant="body1">
              Enter the verification code sent to your new email address.
            </Typography>
          </Box>
          <Stack mb={2}>
            <TextField
              required
              onChange={onChangeEmailVerificationCode}
              error={state.errors?.email ? true : false}
              value={state.submission?.emailVerificationCode || ""}
              fullWidth={true}
              label="Verification Code"
            />
          </Stack>
          <Button onClick={nextStep}>Confirm Verification Code</Button>
        </Stack>
      )}
    </>
  );
};

export const EditProfileScreenOnboarding = ({ ...props }) => {
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();

  const [appDialog, setAppDialog] = useState({ open: false });
  const [globalState, setGlobalState, q, p] = useContext(AppContext);
  const [state, setState] = useState({
    // userData: p.userData,
    erros: p.errors,
    submission: p.submission,
    validated: p.validated || false,
    loading: p.journey === "onboarding" ? false : true,
    openLockButton: p.mutex || 0,
  });

  const mutex = useRef(0);

  const reloadUserData = async () => {
    const res = await client.graphql({
      query: getUser(
        p.userData?.dynamoDB?.id,
        null,
        "ge",
        p.userData?.dynamoDB?.interests?.selectedInterests
      ),
    });

    p.submission = {
      givenName: res?.data?.getUser?.givenName || "",
      familyName: res?.data?.getUser?.familyName || "",
      bio: res?.data?.getUser?.bio || "",
      email: res?.data?.getUser?.email || "",
      phoneNumber: res?.data?.getUser?.phoneNumber || "",
      imagesData: res?.data?.getUser?.images?.items,
      city: res?.data?.getUser?.city || "Dubai",
      cityObj: (res?.data?.getUser?.cityObj &&
        JSON?.parse(res?.data?.getUser?.cityObj)) || {
        id: "292223",
        name: "Dubai",
        country: "AE",
        admin1: "Dubai",
        lat: "25.0772500",
        lon: "55.3092700",
        pop: "2956587",
      },
      selectedInterests: p.userData?.dynamoDB?.interests?.selectedInterests.map(
        (_, i) => res?.data?.[`q${i}`]?.items?.[0]
      ),
      // ...p.submission,
      // ...res.data.getUser,
    };

    setState({
      ...state,
      errors: p.errors,
      validated: p.validated,
      submission: p.submission,
      loading: false,
      userData: {
        ...p.userData,
        ...globalState?.userData,
        dynamoDB: res.data.getUser,
      },
      selectedInterests: p?.submission?.selectedInterests,
      // localChanges: p.localChanges
    });

    // setGlobalState({
    //   ...globalState,
    //   userData: {
    //     ...globalState?.userData,
    //     dynamoDB: res.data.getUser,
    //   },
    // });
  };

  useEffect(() => {
    (async () => {
      p.prevPage = p.currentPage || "edit-profile";
      p.currentPage = "edit-profile";
      p.notificationsFetchLock = 1;
      mutex.current = 0;

      if (p.journey === "onboarding") {
        setState({
          ...state,
          errors: p.errors,
          validated: p.validated,
          submission: p.submission,
          openLockButton: p.mutex || 0,
          //loading: false,
          userData: {
            ...p.userData,
          },
        });
      } else {
        if (p.journey !== "onboarding") {
          reloadUserData();
        }
      }

      if (!p.journey) p.journey = "onboarding";
    })();
  }, []);

  useEffect(() => {
    // Validate fields
    // ---------------------------------------------------------------
    if (mutex.current === 1) {
      // mutex.current = 1;
      p.mutex = mutex.current;
      const bioCondition =
        (state.submission?.bio?.length > 0 &&
          state.submission?.bio?.length <= 900) ||
        state.submission?.bio?.length === 0 ||
        !state.submission?.bio;

      if (
        state.submission?.givenName?.length <= 20 &&
        state.submission?.familyName?.length <= 20 &&
        state.submission?.givenName?.length >= 2 &&
        state.submission?.familyName?.length >= 2 &&
        bioCondition &&
        validateEmail(state.submission?.email)
      ) {
        p.validated = true;
      } else {
        p.validated = false;
      }
      mutex.current = 0;
      setState({
        ...state,
        //loading: false,
        submission: p.submission,
        errors: p.errors,
        validated: p.validated,
      });
    }
  }, [
    state.submission?.givenName,
    state.submission?.familyName,
    state.submission?.bio,
    state.submission?.email,
    state.submission?.phoneNumber,
    state.submission?.city,
  ]);

  const onChangeGivenName = (event) => {
    mutex.current = 1;
    p.mutex = mutex.current;
    const value = capitalizeWords(event.currentTarget.value);
    p.submission = {
      ...p.submission,
      givenName: value,
    };
    if (value.length >= 20) {
      p.errors = {
        ...p.errors,
        givenName: "Enter a valid first name.",
      };
    } else {
      p.errors = {
        ...p.errors,
        givenName: false,
      };
    }
    setState({
      ...state,
      submission: p.submission,
      errors: p.errors,
    });
  };

  const onChangeFamilyName = (event) => {
    mutex.current = 1;
    p.mutex = mutex.current;
    const value = capitalizeWords(event.currentTarget.value);
    p.submission = {
      ...p.submission,
      familyName: value,
    };

    if (value.length >= 20) {
      p.errors = {
        ...p.errors,
        familyName: "Enter a valid family name.",
      };
    } else {
      p.errors = {
        ...p.errors,
        familyName: false,
      };
    }

    setState({
      ...state,
      submission: p.submission,
      errors: p.errors,
    });
  };

  const onChangeBio = (event) => {
    mutex.current = 1;
    p.mutex = mutex.current;
    const value = event.currentTarget.value;
    p.submission = {
      ...p.submission,
      bio: value,
    };
    if (value.length > 900) {
      p.errors = {
        ...p.errors,
        bio: "You have exceeded the limit of 900 characters",
      };
    } else {
      p.errors = {
        ...p.errors,
        bio: false,
      };
    }
    setState({
      ...state,
      submission: p.submission,
      errors: p.errors,
    });
  };

  const onChangeEmail = (event) => {
    mutex.current = 1;
    p.mutex = mutex.current;
    const value = event.currentTarget.value;
    p.submission = {
      ...p.submission,
      email: value,
    };

    if (validateEmail(value)) {
      p.errors = {
        ...p.errors,
        email: false,
      };
    } else {
      p.errors = {
        ...p.errors,
        email: "Enter a valid first email address.",
      };
    }
    setState({
      ...state,
      submission: p.submission,
      errors: p.errors,
    });
  };

  const onClickChangeEmail = () => {
    props.setAppDialog({
      ...props.appDialog,
      confirmText: false,
      dialogChildren: (
        <EmailVerificationBody globalState={globalState} p={p} q={q} />
      ),
      open: true,
      onConfirm: async () => {
        navigate(-1);
      },
    });
  };

  const onChangeCity = (cityObj) => {
    const { name, lat, lon } = cityObj;
    mutex.current = 1;
    p.mutex = mutex.current;
    p.submission = {
      ...p.submission,
      cityObj: cityObj,
      city: name,
      latitude: lat,
      longitude: lon,
    };

    if (!name) {
      p.errors = {
        ...p.errors,
        city: false,
      };
    } else {
      p.errors = {
        ...p.errors,
        city: "Enter a valid city.",
      };
    }
    setState({
      ...state,
      submission: p.submission,
      errors: p.errors,
    });
  };

  const attachPhotoHandler = (event) => {
    const attachedFiles = event.target?.files
      ? Array.from(event.target?.files)
      : [];
    var cancelFlag = 0;

    if (attachedFiles.length > 11) {
      alert("Too many attachments. Max attachments is 1.");
      return;
    }

    if (attachedFiles) {
      // 1. Check file extensions
      attachedFiles.forEach((v, i) => {
        const file = v;
        const slashIndex = file.type.lastIndexOf("/");
        const fileExtension = file.type.substring(slashIndex + 1).toLowerCase();

        if (!acceptableFiles.includes(fileExtension)) {
          cancelFlag = 1;
          alert("This file format is not allowed.");
          return;
        }
      });
    }

    if (event?.target?.files) {
      const imagesData = [];

      Array.from(event.target.files).forEach((file, i) => {
        // const file = event.target.files[0];
        const previewURL = URL.createObjectURL(file);
        imagesData.push({
          label: file.name,
          url: previewURL,
        });
      });

      p.submission.imagesData = imagesData;
      p.submission.files = event.target.files;

      setState({
        ...state,
        submission: p.submission,
      });
    }
  };

  const onConfirmHandler = async (event) => {
    if (p.journey === "onboarding") {
      navigate("/profile-information/select-interests");
    } else {
      try {
        q.updateState(globalState);
        const res = await q.doQuery(
          "updateProfile",
          "Profile updated",
          "An error occured",
          {
            submission: p.submission,
          },
          p,
          p?.userData?.userId,
          state.submission?.givenName,
          state.submission?.familyName,
          state.submission?.bio,
          state.submission?.email,
          state.submission?.cityObj,
          state.submission?.city,
          state.submission?.latitude,
          state.submission?.longitude,
          state.submission?.selectedInterestsID
        );

        delete p.mutex;
        delete p.validated;
        if (p.submission?.files?.length > 0) {
          await uploadImages(
            "PROFILE",
            p.submission?.files,
            p?.userData?.userId,
            "user/profile",
            //Callback for when images are done uploading
            () => {
              // alert("Activity created succesfully!");
              // setState({
              //   ...state,
              //   loading: false,
              // });
              // setGlobalState({
              //   ...globalState,
              //   currentUserData: {
              //     ...p.submission,
              //   },
              // });
              // navigate(-1);
              if (p.journey === "onboarding") {
                delete p.mutex;
                delete p.validated;

                navigate("/profile-information/select-interests");
              } else {
                delete p.mutex;
                delete p.validated;
                navigate(`/profile-information`);
              }
            },
            (uploadProgress) => {
              console.log(uploadProgress);
            }
          );
        } else {
          if (p.journey === "onboarding") {
            navigate("/profile-information/select-interests");
          } else {
            navigate(`/profile-information`);
          }
        }
      } catch (error) {
        console.log("error", error);
      }
      navigate(-1);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth={"sm"}>
        <Box>
          <ScreenNavHeader
            backButtonDisabled={globalState?.queryLoading}
            title={`Edit Profile`}
            to={`/profile-information`}
          >
            <Button
              onClick={onConfirmHandler}
              disabled={
                (!state.validated && state.openLockButton !== 1) ||
                globalState?.queryLoading
              }
              size={"large"}
            >
              {globalState?.queryLoading && (
                <CircularProgress
                  size={18}
                  sx={{
                    mr: 1,
                    ml: -0.5,
                    color: "rgba(0,0,0,0.25)",
                  }}
                />
              )}
              Confirm
            </Button>
          </ScreenNavHeader>

          {state.loading && (
            <Stack my={4} alignItems={"center"}>
              <CircularProgress sx={{ color: "#2D9CDB" }} />
            </Stack>
          )}

          {!state.loading && (
            <Box flexGrow={1} mb={6}>
              <Stack
                mb={2}
                direction="column"
                spacing={2}
                alignItems={"center"}
              >
                <TextField
                  required
                  error={state.errors?.givenName ? true : false}
                  onChange={onChangeGivenName}
                  value={state.submission?.givenName || ""}
                  fullWidth={true}
                  label="First Name"
                />
                <TextField
                  required
                  error={state.errors?.familyName ? true : false}
                  onChange={onChangeFamilyName}
                  value={state.submission?.familyName || ""}
                  fullWidth={true}
                  label="Last Name"
                />
                <TextField
                  required
                  onChange={onChangeBio}
                  value={state.submission?.bio || ""}
                  error={state.errors?.bio ? true : false}
                  multiline
                  fullWidth={true}
                  minRows={4}
                  maxRows={6}
                  label="About Me (Optional)"
                />

                {p.journey === "onboarding" && (
                  <TextField
                    required
                    onChange={onChangeEmail}
                    error={state.errors?.email ? true : false}
                    value={state.submission?.email || ""}
                    fullWidth={true}
                    label="Email"
                  />
                )}
                {p.journey !== "onboarding" && (
                  <>
                    <Stack
                      mb={2}
                      direction={"row"}
                      justifyContent={"space-between"}
                      sx={{ width: "100%" }}
                    >
                      <Typography>{state.submission?.email}</Typography>
                      <IconButton onClick={onClickChangeEmail}>
                        <SvgIcon>
                          <EditIcon />
                        </SvgIcon>
                      </IconButton>
                    </Stack>

                    <Stack
                      mb={2}
                      direction={"row"}
                      justifyContent={"space-between"}
                      sx={{ width: "100%" }}
                    >
                      <Typography>{state.submission?.phoneNumber}</Typography>
                      <IconButton disabled>
                        <SvgIcon>
                          <EditIcon />
                        </SvgIcon>
                      </IconButton>
                    </Stack>
                  </>
                )}

                {state.submission?.cityObj ? (
                  <CountrySelectField
                    callback={onChangeCity}
                    cityObj={state.submission?.cityObj}
                  />
                ) : (
                  <CountrySelectField
                    callback={onChangeCity}
                    cityObj={{
                      id: "292223",
                      name: "Dubai",
                      country: "AE",
                      admin1: "Dubai",
                      lat: "25.0772500",
                      lon: "55.3092700",
                      pop: "2956587",
                    }}
                  />
                )}
              </Stack>

              {!state.userData?.userId &&
              p.journey !== "onboarding" &&
              p.journey !== "edit-profile" ? (
                <>
                  <Skeleton
                    variant="circular"
                    sx={{ width: 196, height: 196, margin: "0 auto" }}
                  />
                </>
              ) : state.submission?.imagesData?.length >= 1 ||
                state?.userData?.dynamoDB?.images?.items?.[0]?.url ? (
                <>
                  <Box
                    component="img"
                    sx={{
                      background: `url("${
                        state.submission?.imagesData?.[0]?.url?.replace(
                          "//cdn.qa.sociogram.com/",
                          "//d2mgxt9bsinkzr.cloudfront.net/fit-in/248x248/"
                        ) ||
                        state?.userData?.dynamoDB?.images?.items?.[0]?.url?.replace(
                          "//cdn.qa.sociogram.com/",
                          "//d2mgxt9bsinkzr.cloudfront.net/fit-in/248x248/"
                        )
                      }") center center`,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      margin: `${4 * 8}px auto ${4 * 4}px auto`,
                      height: 196,
                      width: 196,
                      borderRadius: "100%",
                      textAlign: "center",
                      textTransform: "none",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                    }}
                  ></Box>
                </>
              ) : (
                <UploaderButton
                  uploadDataInBrowser={attachPhotoHandler}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: `${4 * 8}px auto`,
                    background: "#F1F8F9",
                    height: 196,
                    width: 196,
                    border: "dashed 2px #B9DEF3",
                    borderRadius: "100%",
                    textAlign: "center",
                    textTransform: "none",
                  }}
                >
                  <Stack direction={"column"} spacing={1} alignItems={"center"}>
                    <SvgIcon sx={{ height: 48, width: 48, color: "#132B39" }}>
                      <AddPhotoAlternateIcon />
                    </SvgIcon>
                    <Typography
                      sx={{ color: "#132B39" }}
                      variant="h6"
                      fontWeight={"bold"}
                    >
                      Add Photo
                    </Typography>
                  </Stack>
                </UploaderButton>
              )}
              {(state.submission?.imagesData?.[0]?.url ||
                state?.userData?.dynamoDB?.images?.items?.[0]?.url) && (
                <Stack alignItems={"center"}>
                  {p.journey === "onboarding" ? (
                    <Button size="small" component="label">
                      Edit Photos
                      <VisuallyHiddenInput
                        type="file"
                        onChange={attachPhotoHandler}
                      />
                    </Button>
                  ) : (
                    <Button
                      size="small"
                      component={ReactLink}
                      to={"/edit-profile/photos"}
                    >
                      {p.journey === "onboarding"
                        ? "Change Photo"
                        : "Edit Photos"}
                    </Button>
                  )}
                </Stack>
              )}
            </Box>
          )}
        </Box>
      </Container>

      <AppDialog
        open={appDialog.open}
        buttonDisabled={appDialog.buttonDisabled}
        maxButtonWidth={275}
        confirmText={undefined}
        onConfirm={() => {
          appDialog.onConfirm();
          setAppDialog({ ...appDialog, open: false });
        }}
        onClose={() => setAppDialog({ ...appDialog, open: false })}
      >
        {appDialog.dialogChildren}
      </AppDialog>
    </ThemeProvider>
  );
};

export const EditProfileScreenLayout = (props) => {
  return (
    <ResponsiveLayoutSidebar waitForUserData={props.waitForUserData}>
      <EditProfileScreenOnboarding {...props} />
    </ResponsiveLayoutSidebar>
  );
};

export const EditProfileScreenOnboardingLayout = (props) => {
  return (
    <OnboardingScreenResponsiveLayout
      mtLogo={{ xs: 0, md: 8*2}}
      reponsivePositionBoxSx={{
        pt: { xs: 14, sm: 4 },
      }}
      waitForUserData={props.waitForUserData}
    >
      <EditProfileScreenOnboarding {...props} />
    </OnboardingScreenResponsiveLayout>
  );
};

EditProfileScreenOnboarding.propTypes = {};

EditProfileScreenOnboarding.defaultProps = {
  color: "primary",
};
